"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
exports.PropertiesIcon = function () { return (React.createElement(common_1.PropertyTable, null,
    React.createElement(common_1.Property, { name: "name", type: "string", description: "Icon name." }),
    React.createElement(common_1.Property, { name: "color", type: "string", defaultValue: "#727272", description: "Sets the background color." }))); };
exports.PropertiesIcon.displayName = 'PropertiesIcon';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentIconPage/PropertiesIcon.tsx
// module id = 686
// module chunks = 0